import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { FileType } from '../models/fileType';
import { Pagination } from '../models/pagination';
import { Project } from '../models/project';
import { FilterProjectsForm } from '../pages/Projects/FilterProjects';

const baseUrl = '/project';

const createProject = (
  project: Project,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Project>> =>
  axios.post<Project>(baseUrl, project, config);

const getProjectById = (id: number): Promise<AxiosResponse<Project>> =>
  axios.get(`${baseUrl}/${id}`);

const closeProjectById = (id: number): Promise<AxiosResponse<void>> =>
  axios.patch(`${baseUrl}/${id}`);

const getProjectRequest = (): Promise<AxiosResponse<Pagination<Project>>> =>
  axios.get<Pagination<Project>>(`${baseUrl}/requests`);

const updateProject = (project: Project): Promise<AxiosResponse<void>> =>
  axios.put<void>(baseUrl, project);

const getProjects = (
  data?: FilterProjectsForm,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Pagination<Project>>> =>
  axios.post<Pagination<Project>>(`${baseUrl}/filter`, data, config);

const exportProjects = (
  data?: FilterProjectsForm
): Promise<AxiosResponse<string>> =>
  axios.post(`${baseUrl}/export`, data, { responseType: 'blob' });

const saveProjectFiles = (
  projectId: number,
  filesData: FormData
): Promise<AxiosResponse<FileType[]>> =>
  axios.post<FileType[]>(`${baseUrl}/files/${projectId}`, filesData);

const deleteProject = (id: number): Promise<AxiosResponse<void>> =>
  axios.delete<void>(`${baseUrl}/${id}`);

const acceptProject = (id: number): Promise<AxiosResponse<void>> =>
  axios.put<void>(`${baseUrl}/accept/${id}`);

const acceptProjectMessage = (payload: {
  projectId: number;
  message: string;
}): Promise<AxiosResponse<void>> =>
  axios.post<void>(`${baseUrl}/accept-message`, payload);

const declineProject = (body: {
  projectId: number;
  declineReason: string;
}): Promise<AxiosResponse<void>> => axios.put<void>(`${baseUrl}/decline`, body);

const sendProjectMessage = (payload: {
  projectId: number | undefined;
  message: string;
}): Promise<AxiosResponse<void>> =>
  axios.post<void>(`${baseUrl}/message`, payload);

export const projectService = {
  getProjects,
  createProject,
  getProjectById,
  acceptProject,
  declineProject,
  updateProject,
  deleteProject,
  exportProjects,
  getProjectRequest,
  saveProjectFiles,
  closeProjectById,
  acceptProjectMessage,
  sendProjectMessage
};
